import { render, staticRenderFns } from "./barter.vue?vue&type=template&id=9370e96e&scoped=true&"
import script from "./barter.vue?vue&type=script&lang=js&"
export * from "./barter.vue?vue&type=script&lang=js&"
import style0 from "./barter.vue?vue&type=style&index=0&id=9370e96e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9370e96e",
  null
  
)

export default component.exports